import { headerWidgetSlice } from './reducers';

export const showHeaderWidgetAction =
  headerWidgetSlice.actions.showHeaderWidget;

export const hideHeaderWidgetAction =
  headerWidgetSlice.actions.hideHeaderWidget;
